import React from 'react';
import { Link } from 'react-router-dom';

const CareerAssessment = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <Link to="/services/career" className="text-indigo-600 hover:text-indigo-700 mb-4 inline-block">
          Back to Career Dashboard
        </Link>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Career Assessment</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-gray-600 mb-4">
            Discover your career potential with our comprehensive assessment tool.
          </p>
          <p className="text-sm text-gray-500">Coming soon: Interactive career assessment questionnaire</p>
        </div>
      </div>
    </div>
  );
};

export default CareerAssessment;
